import gql from "graphql-tag";

export const FullTopicFragment = gql`
    fragment FullTopic on Topic {
        id
        slug
        stage

        title
        headline
        description

        podcasts {
            id
            title
            shortdescription
            publicationDate
        }

        sections(orderBy: sortIndex_ASC) {
            id
            slug

            headline
            description
            table
            localizedHotspotImage {
                handle
                fileName
                width
                height
                url
                mimeType
            }

            hotspotImage(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }

            hotspots(orderBy: sortIndex_ASC) {
                posX
                posY

                headline
                description
            }

            assetWithDescription(orderBy: sortIndex_ASC) {
                id
                asset(locales: [$lang, de]) {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }

                description
                localizedAsset {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }
            }
        }
    }
`;

export default gql`
    query Topic($slug: String!, $lang: Locale!, $stage: Stage!) {
        topic(where: { slug: $slug }, locales: [$lang], stage: $stage) {
            ...FullTopic
        }
    }
    ${FullTopicFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/topic.js